import React, {useEffect} from "react";
import queryString from "query-string";
import HashLoader from "react-spinners/HashLoader";
import {authService} from "../../services/auth.service";
import {useHistory} from "react-router-dom";
import {isMobile} from "react-device-detect";
import environment from "../../environment";

export default function ActivateUser() {
	const history = useHistory();

	function navigate(path) {
		window.location.replace(path);
	}

	useEffect(() => {
		const getToken = async () => {
			const parsed = queryString.parse(location.search);
			if (Object.keys(parsed).length && parsed.token) {
				const activated = await new authService().activateUser(parsed.token);
				if (activated && activated.token) {
					if (isMobile) {
						if (environment?.country === "DE") {
							const userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
							let deepLinkUrl = "";
							if (/android/i.test(userAgent)) {
								// Android-specific deep link
								deepLinkUrl = `de.taxefy.android://email-verification?token=${activated.token}`;
							} else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
								// iOS-specific deep link
								deepLinkUrl = `de.taxefy.app://email-verification?token=${activated.token}`;
							}
							if (deepLinkUrl) {
								navigate(deepLinkUrl);
								setTimeout(() => {
									history.push("/auth/login");
								}, 100);
							}
						} else {
							navigate(`at.taxefy.app://email-verification?token=${activated.token}`);
							setTimeout(() => {
								history.push("/auth/login");
							}, 100);
						}
					}
				} else {
					history.push("/404");
				}
			}
		};
		getToken();
	}, []);

  return(
    <>
      <HashLoader color="gray" size={35} />
    </>
  );
}
